/*
	generic Blog Post component
*/

<template>
	<div>
		<h1 class="red">Blog Post View</h1>
	</div>

</template>


<script>
	export default {

		data () {
			return {
			}
		}
	}
</script>


<style>
	.red {
		color: #f00;
	}
</style>



// WEBPACK FOOTER //
// BlogPostView.vue?72e0ac66